// NOTE: This implementation is incompatible with IE browsers!
// ------------------------------------------------------------------------- //

const dispatch = (name, data = {}, cancellable = true) => {
  let event = new CustomEvent(name, {
    bubbles: true,
    composed: true,
    cancel: cancellable,
    detail: data,
  });
  document.dispatchEvent(event);
};

const off = (event, fn) => {
  document.removeEventListener(event, fn);
};

const on = (event, fn) => {
  document.addEventListener(event, fn);
  return () => off(event, fn);
};

const Events = {
  on,
  off,
  dispatch,
};

// exports ----------------------------------------------------------------- //

export default Events;
